import actionTypes from "../constants/actionTypes"

const initialState = {
    userInfo: {
        name: "",
        phone: "",
        email: "",
    },
    isLoadingUserInfo: false,
    userInfoError: null,
    isSubmittingTerms: false,
    termsError: null,
    termsSuccess: false,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.USER_INFO_FETCH:
            return {
                ...state,
                isLoadingUserInfo: true,
                userInfoError: null,
            }
        case actionTypes.USER_INFO_FETCH_SUCCEED:
            return {
                ...state,
                isLoadingUserInfo: false,
                userInfo: {
                    name: action.payload.name || "정보 없음",
                    phone: action.payload.phone || "정보 없음",
                    email: action.payload.email || "정보 없음",
                },
                userInfoError: null,
            }
        case actionTypes.USER_INFO_FETCH_FAILED:
            return {
                ...state,
                isLoadingUserInfo: false,
                userInfo: {
                    name: "홍길동",
                    phone: "010-1234-5678",
                    email: "user@example.com",
                },
                userInfoError: action.payload,
            }

        case actionTypes.USER_INFO_INPUT_FETCH:
            return {
                ...state,
                isSubmittingMember: true,
                memberError: null,
                memberSuccess: false,
            }
        case actionTypes.USER_INFO_INPUT_FETCH_SUCCEED:
            return {
                ...state,
                isSubmittingMember: false,
                memberSuccess: true,
                memberError: null,
            }
        case actionTypes.USER_INFO_INPUT_FETCH_FAILED:
            return {
                ...state,
                isSubmittingMember: false,
                memberSuccess: false,
                memberError: action.payload,
            }
        default:
            return state
    }
}
